import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4801Model } from '../kymw4801.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// リクエスト構造
interface CheckUnselectedGoodsRequest {
  parameter: {
    OrderCode: string;
    MediumType: string;
    PCode: string;
  };
}

// レスポンス構造
interface CheckUnselectedGoodsResponse {
  /** 結果 (0:選定済 / 1:未選定) */
  CheckResult: string;
}

/**
 * 商品未選定チェックサービス
 * @export CheckUnselectedGoodsService
 * @class CheckUnselectedGoodsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CheckUnselectedGoodsService extends PlessJsonResponderSub<any> {
  private model: KYMW4801Model;
  private successFunc: (data: CheckUnselectedGoodsResponse) => void;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CheckUnselectedGoodsService
   */
  private getBody(): PlessRequest {
    const request: CheckUnselectedGoodsRequest = {
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        PCode: this.vo.pCode,
      }
    };

    return new PlessRequest(request);
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4801Model} model モデルクラス
   * @param {any} vo 
   * @param {Function} func 成功時後続処理
   * @memberof CheckUnselectedGoodsService
   */
  execute(model: KYMW4801Model, vo: any, func?:(data: CheckUnselectedGoodsResponse) => void): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = func;
    this.send('checkUnselectedGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CheckUnselectedGoodsService
   */
  success(data: CheckUnselectedGoodsResponse): void {
    if (this.successFunc) {
      this.successFunc(data);
    }
  }
}
